// extracted by mini-css-extract-plugin
export default {"stone":"MemorySymbolV1_stone-dM2"};